import {IWithSummaryModel} from '../../../../../common/permission/api/entity/iWithSummary.model';
import {TreatmentDefinitionSummaryModel} from './treatmentDefinitionSummaryModel';
import {FormDefinitionFormModel} from '../../../../../form/definition/form/api/entity/formDefinitionForm.model';

export class TreatmentDefinitionModel implements IWithSummaryModel<TreatmentDefinitionSummaryModel> {
    formDefinition: FormDefinitionFormModel;
    summary: TreatmentDefinitionSummaryModel;
}
